import { AnyAction } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '../';
import { N2NDeferredPasswordFieldsType } from '../../layouts/devops-screen/types';

type N2NDeferredPasswordFieldProgressActionType = {
  readonly type: string;
  readonly payload?: {
    readonly fieldName: 'email' | 'fullName';
    readonly isPopulated: boolean;
  };
};

// Actions
const INPUT_POPULATED_EMAIL = 'n2n-field-progress/INPUT_POPULATED_EMAIL';
const INPUT_POPULATED_FULL_NAME =
  'n2n-field-progress/INPUT_POPULATED_FULL_NAME';

// Initial State
const initialState: N2NDeferredPasswordFieldsType = {
  email: false,
  fullName: false
};

// Reducer
export const n2nDeferredPasswordFieldProgressReducer = (
  state = initialState,
  action: N2NDeferredPasswordFieldProgressActionType
): N2NDeferredPasswordFieldsType => {
  switch (action.type) {
    case INPUT_POPULATED_EMAIL:
    case INPUT_POPULATED_FULL_NAME:
      return Object.assign({}, state, {
        [action?.payload?.fieldName as string]: action?.payload?.isPopulated
      });
    default:
      return state;
  }
};

// Thunks
export function updateN2NDeferredPasswordFieldProgressEmail(payload: boolean) {
  return ((dispatch: AppDispatch, getState: () => RootState) => {
    const {
      n2nFieldProgress: { email }
    } = getState();
    if (email !== payload) {
      dispatch({
        type: INPUT_POPULATED_EMAIL,
        payload: {
          fieldName: 'email',
          isPopulated: payload
        }
      });
    }
  }) as unknown as AnyAction;
}

export function updateN2NDeferredPasswordFieldProgressFullName(
  payload: boolean
) {
  return ((dispatch: AppDispatch, getState: () => RootState) => {
    const {
      n2nFieldProgress: { fullName }
    } = getState();
    if (fullName !== payload) {
      dispatch({
        type: INPUT_POPULATED_FULL_NAME,
        payload: {
          fieldName: 'fullName',
          isPopulated: payload
        }
      });
    }
  }) as unknown as AnyAction;
}
